export default __webpack_public_path__ + "static/929-50fc174c84e25f096185e247d9c789c5.gif";